import { API_BASE } from "@/lib/api";
import { PageHeader } from "@/components/Common";
import { Button } from "@/components/ui/button";
import { FileDown, FileText } from "lucide-react";

export default function Reports() {
  const download = (path, filename) => {
    // fetch with credentials, then trigger download to preserve cookie
    fetch(`${API_BASE}${path}`, { credentials: "include" })
      .then((r) => r.blob())
      .then((b) => {
        const url = URL.createObjectURL(b);
        const a = document.createElement("a");
        a.href = url; a.download = filename; a.click();
        URL.revokeObjectURL(url);
      });
  };

  return (
    <div data-testid="reports-page">
      <PageHeader eyebrow="Report" title="Documenti PDF"
        subtitle="Genera report settimanali e mensili pronti per il commercialista." />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="border border-[#E2D9C8] rounded-lg p-8 bg-white">
          <FileText size={28} strokeWidth={1.2} className="text-neutral-400" />
          <h2 className="font-serif text-3xl mt-4">Report Settimanale</h2>
          <p className="text-neutral-500 mt-3">Conto economico, scontrini, costi per categoria della settimana corrente.</p>
          <Button data-testid="download-weekly" onClick={() => download("/reports/weekly.pdf", "report-settimanale.pdf")}
            className="mt-6 bg-neutral-900 hover:bg-neutral-800 text-[#FDFBF7]">
            <FileDown size={14} strokeWidth={1.5} /> Scarica PDF
          </Button>
        </div>
        <div className="border border-[#E2D9C8] rounded-lg p-8 bg-[#F3EDE1]">
          <FileText size={28} strokeWidth={1.2} className="text-neutral-600" />
          <h2 className="font-serif text-3xl mt-4">Report Mensile</h2>
          <p className="text-neutral-600 mt-3">Documento completo per il commercialista: conto economico, incidenza personale, valore magazzino, costi per categoria.</p>
          <Button data-testid="download-monthly" onClick={() => download("/reports/monthly.pdf", "report-mensile.pdf")}
            className="mt-6 bg-neutral-900 hover:bg-neutral-800 text-[#FDFBF7]">
            <FileDown size={14} strokeWidth={1.5} /> Scarica PDF
          </Button>
        </div>
      </div>

      <div className="mt-8 text-sm text-neutral-500 border-l-2 border-[#D7C4A3] pl-4">
        I PDF sono generati in tempo reale sui dati attuali del gestionale. Ogni volta che lo scarichi ricevi la versione aggiornata.
      </div>
    </div>
  );
}
